import React from 'react'

import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Avatar from '@material-ui/core/Avatar'
import Typography from '@material-ui/core/Typography'

import { useStyles } from './styles'
import { flags, useFeatureFlags } from 'lib/feature-flags'
import useIsMobile from 'lib/hooks/use-is-mobile'

const CoachOfferingCard = ({ coach }) => {
  const classes = useStyles()
  const isMobile = useIsMobile()
  const { id, name, coachProfile } = coach
  const [isOfferingsRefreshEnabled] = useFeatureFlags([
    flags.FLAG_FEAT_COACH_OFFERING_REFRESH,
  ])

  const coachNameVariant = isOfferingsRefreshEnabled ? 'h4' : 'body1'
  const cardClasses = isOfferingsRefreshEnabled ? classes.disableSpacing : null

  return (
    <Card key={id} className={classes.root}>
      <CardContent className={`${classes.coachInfo} ${cardClasses}`}>
        <Avatar
          className={classes.coachAvatar}
          alt={name}
          src={coachProfile?.profilePhoto}
          style={{ marginRight: isMobile ? '1rem' : '36px' }}
        >
          {name.substring(0, 1)}
        </Avatar>
        <div>
          <Typography variant={coachNameVariant}>{name}</Typography>
          {coachProfile?.title ? (
            <Typography variant="caption" className={classes.coachTitle}>
              {coachProfile.title}
            </Typography>
          ) : null}
        </div>
        {/* member logo place holder */}
      </CardContent>
    </Card>
  )
}

export default CoachOfferingCard
